import React, { forwardRef, memo, useEffect, useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Input } from '@material-ui/core'
import { CheckBox, TextField, ThemeButton } from 'irmlib/components/Controls'
import { ErrorMessage } from 'irmlib/components/FormControls/common'
import { formatPatterns, optionalFormatPattern } from '../../../common/constants'
import { useTranslation } from 'react-i18next'

const FormatContainer = styled.div`
  display: block;
`

const CharacterList = styled.li`
`

const CharacterListConatiner = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-top: 3px;
`
  
const Character = styled.p`
  padding-right: 5px;
  display: inline-block;
  margin: 3px 3px 0;
`
const Description = styled.p`
    margin-left: 7%;
    margin-top: 0;
    color: #7D7A7A;
`

const LengthContainer = styled.div`
   margin-top: 10px;
`

const ButtonContainer = styled.div`
   margin-top: 5%;
   display: flex;
   justify-content: center;
`

const FormatCustomOption = memo(forwardRef((props, ref) => {
  const { t } = useTranslation()
  const { customLength, actualLength, specifyLength = '' } = props.rowData
  // Allowed characters for define field format
  const allowedCharacters = Object.keys(formatPatterns)
  const maxLengthAllowed = customLength || actualLength
  const [isSaveBtnDisabled, handleSaveButtonDisabled] = useState(true)
  const [isChecked, handleCheckbox] = useState(Boolean(specifyLength))
  const [checkBoxDisabled, setCheckBoxDisabled] = useState(false)
  const [error, handleErrors] = useState({
    format: { status: false, message: '' },
    length: { status: false, message: '' },
  })
  const [format, setFormatValue] = useState(props?.existingCustomValue)
  const [length, setLength] = useState(specifyLength || customLength || actualLength)

  const validateAndGenerateRegexPattern = (value) => {
    const valueArray = value.split('')
    const error = { status: false, message: '' }
    const charLengthValidation = value?.length > maxLengthAllowed
    let pattern = ''
    // count optional format pattern character: a and 9 are optional format letter
    const optionalCharsLength = (value.match(new RegExp(`${optionalFormatPattern[0]}|${optionalFormatPattern[1]}`, 'g')) || []).length
    if (value) {
      // adding leading zeros if specified length mentioned and length should be greater than format length (exclude optional char)
      if (isChecked && length > (value.length - optionalCharsLength)) {
        // substract specified length with format string length
        const leadingZerosLength = length - value.length
        // add leadingZerosLength and optionalCharsLength to get total leading zeros to be added in the data entry screen
        const leadingZerosTotalLength = leadingZerosLength + optionalCharsLength
        // form regex pattern that allow leading zeros as optional in the value
        pattern = `([0]{0,${leadingZerosTotalLength}})?`
      }
      valueArray.forEach(val => {
        if (allowedCharacters.includes(val)) {
          // generate regex pattern for each character and concatinate with existing pattern
          pattern = pattern + formatPatterns[val]
        } else {
          pattern = ''
          error.status = true
          error.message = `${t('forms.invalidFormat')}`
        }
      })
    }
    if (charLengthValidation) {
      error.status = true
      error.message = `${t('forms.maxFieldLength')} ${actualLength}`
    }
    if (pattern) pattern = `^${pattern}$`
    return { pattern, error }
  }

  const handleFormatCheckbox = (status) => {
    handleCheckbox(status)
  }

  // save custom format value and validations
  const handleChange = (value) => {
    if (value.length > 0) {
      setCheckBoxDisabled(true)
    } else {
      setCheckBoxDisabled(false)
    }
    
    const validateFormat = { status: false, message: '' }
    // if (!value) {
    //   validateFormat.status = true
    //   // validateFormat.message = translate('forms.required')
    // } else {
    const result = validateAndGenerateRegexPattern(value)
    validateFormat.status = result.error?.status
    validateFormat.message = result.error?.message
    // }

    handleErrors(err => {
      return {
        ...err,
        format: validateFormat,
      }
    })
    setFormatValue(value)
  }

  // save custom length and validations
  const handleLengthChange = (value) => {
    const validateLength = { status: false, message: '' }
    if (parseInt(value) > maxLengthAllowed) {
      validateLength.status = true
      validateLength.message = `${t('forms.maxValue')} ${maxLengthAllowed}`
    }

    if (value < 0) {
      validateLength.status = true
      validateLength.message = `${t('forms.minValue')} 0`
    }

    setLength(value)
    handleErrors(err => {
      return {
        ...err,
        length: validateLength,
      }
    })
  }

  // handle dialoge save action
  const handleDialogSave = () => {
    if (error?.length?.status || error?.format?.status) {
      handleSaveButtonDisabled(true)
    } else if (!error?.format.status && !error?.length?.status) {
      const specifiedLength = length
      const validateFormat = validateAndGenerateRegexPattern(format)
      props.handleDialogSave && props.handleDialogSave(specifiedLength, validateFormat?.pattern)
    } 
  }

  const handleCancel = () => {
    props.handleCancel && props.handleCancel()
  }
  
  useEffect(() => {
    if (error?.length?.status || error?.format?.status) {
      handleSaveButtonDisabled(true)
    } else if (!error?.format?.status && !error?.length?.status) {
      if (format || isChecked) {
        handleSaveButtonDisabled(false)
      } else handleSaveButtonDisabled(true)
    }
  }, [error?.format, error?.length, isChecked])

  return (
    <FormatContainer id='custom_format_field'>
      <TextField id={'formatCustomField_formatRequired'} inputProps={{ maxLength: length }} label={t('formatRequired.textFieldLabel')} value={format} onChange={handleChange} error={error.format?.status} ref={ref} fullWidth={false} disabled={isChecked} noTranslate/>
      {error?.format?.status
        ? <ErrorMessage 
            styles={{
              marginBottom: '3px',
              marginTop: '3px',
            }} 
            errorMsg={error?.format?.message}
            ></ErrorMessage>
        : ''}
      <LengthContainer>
        <CheckBox id={'formatCustomField_checkBox'} label={t('formatRequired.checkboxLabel')}onChange={handleFormatCheckbox} defaultValue={isChecked} disabled={checkBoxDisabled} noTranslate /> 
        <Input id={'formatCustomField_inuptFieldLength'} value={length} fullWidth={false} type='number' onChange={(e) => handleLengthChange(e?.target?.value)} error={error?.length?.status} disabled={!isChecked} />
        {error?.length?.status
          ? <ErrorMessage 
              styles={{
                marginLeft: '7%',
                marginBottom: '3px'
              }} 
              errorMsg={error?.length?.message}
            ></ErrorMessage>
          : ''}
        {isChecked ? <Description>{t('formatRequired.dialog.lengthDesc')}</Description> : ''}
      </LengthContainer>
      <div>
        {t('formatRequired.dialog.fieldFormat')}
      </div>
      <CharacterListConatiner>
        <CharacterList><span><Character>#</Character>{t('formatRequired.dialog.numericPlaceholder')}</span></CharacterList>
        <CharacterList><span><Character>A</Character>{t('formatRequired.dialog.alphanumericRequired')}</span></CharacterList>
        <CharacterList><span><Character>a</Character>{t('formatRequired.dialog.alphanumericOptional')}</span></CharacterList>
        <CharacterList><span><Character>9</Character>{t('formatRequired.dialog.numericOptional')}</span></CharacterList>
        <CharacterList><span><Character>/</Character>{t('formatRequired.dialog.dateSeparator')}</span></CharacterList>
        <CharacterList><span><Character>.</Character>{t('formatRequired.dialog.decimalSeparator')}</span></CharacterList>
        <CharacterList><span><Character>,</Character>{t('formatRequired.dialog.thousandSeparator')}</span></CharacterList>
        <CharacterList><span><Character>:</Character>{t('formatRequired.dialog.timeSeparator')}</span></CharacterList>
        <CharacterList><span><Character>-</Character>{t('formatRequired.dialog.ssnSeparator')}</span></CharacterList>

      </CharacterListConatiner>

      <ButtonContainer>
        {/* ref={dialogObj.customSaveRef} */}
        <ThemeButton id={'formatCustomField_button_cancel'} noTranslate={false} size='medium' color='primary' variant='outlined' onClick={handleCancel}>
          buttons.cancel
        </ThemeButton>
        <div style={{ paddingLeft: '6%' }}>
          <ThemeButton id={'formatCustomField_button_save'} noTranslate={false} size={'medium'} color='primary' variant='contained' autoFocus onClick={handleDialogSave} disabled={isSaveBtnDisabled}>
            buttons.save
          </ThemeButton>
        </div>
      </ButtonContainer>
    </FormatContainer>
  )
}))


FormatCustomOption.propTypes = {
  rowData: PropTypes.object,
  existingCustomValue: PropTypes.string,
  handleDialogSave: PropTypes.func,
  handleCancel: PropTypes.func
}

export default FormatCustomOption